'use client';

import React, { useState } from 'react';
import { VStack, Text, HStack } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
import StarIngredientItem from './components/StarIngredientItem';
import StarIngredientsModal from './components/StarIngredientsModal';
import { useProductService } from '@skin-seoul/service';
import { overlay } from 'overlay-kit';
import SectionContainer from '../../components/SectionContainer';
interface StarIngredientsSectionProps {
  productId: string;
}
const StarIngredientsSection = ({
  productId
}: StarIngredientsSectionProps) => {
  const {
    useGetProductMeta
  } = useProductService();
  const {
    data: productMeta
  } = useGetProductMeta({
    productId
  });
  const {
    starIngredient
  } = productMeta.taxonomies;
  const [expandedItem, setExpandedItem] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setExpandedItem(expandedItem === index ? null : index);
  };
  const handleViewAll = () => {
    overlay.open(({
      isOpen,
      close
    }) => <StarIngredientsModal isOpen={isOpen} onClose={close} starIngredients={starIngredient} />);
  };
  if (starIngredient.length === 0) {
    return null;
  }
  return <SectionContainer headerTitle="Star Ingredients" headerRightContent={<HStack gap={1} alignItems="center" justifyContent="flex-end" cursor="pointer" onClick={handleViewAll}>
          <Text textStyle={{
      base: 'label.small',
      tablet: 'label.medium'
    }} fontWeight="normal" color="neutral.600" textAlign="left" whiteSpace="nowrap">
            View all ({starIngredient.length})
          </Text>
          <LucideIcon name="ChevronRight" size={{
      base: 'md',
      tablet: 'lg'
    }} color="neutral.600" />
        </HStack>} data-sentry-element="SectionContainer" data-sentry-component="StarIngredientsSection" data-sentry-source-file="StarIngredientsSection.tsx">
      <VStack gap={2} width="100%" alignItems="stretch" data-sentry-element="VStack" data-sentry-source-file="StarIngredientsSection.tsx">
        {starIngredient.slice(0, 4).map((ingredient, index) => <StarIngredientItem key={index} name={ingredient.engName} efficacy={ingredient.efficacy} efficacyDescription={ingredient.efficacyDescription} isExpanded={expandedItem === index} onToggle={() => handleToggle(index)} />)}
      </VStack>
    </SectionContainer>;
};
export default StarIngredientsSection;